import gql from 'graphql-tag';

export default gql`
  query bookingsWithLuggage($travelDate: String!, $stationUIC: String) {
    bookingsWithLuggage(travelDate: $travelDate, stationUIC: $stationUIC) {
      bookingReference
      bookingStatus
      trainNumber
      passenger {
        type
        disabilityType
        firstName
        lastName
        email
        phoneNumber
        coach
        seat
        inventoryClass
      }
      outboundRoute {
        origin
        originUic
        destination
        destinationUic
        dateTime
      }
      extra {
        itemRef
        productCode
        productName
        coachNumber
        trainSeal
        itemSeal
      }
    }
  }
`;
